import { useCallback } from "react";

import { useLocalStorage } from "@/lib/hooks/useLocalStorage";

const STORAGE_KEY = "falcon_recent_tenant_ids";
const MAX_RECENT = 5;

function pushRecent(ids: string[], tenantId: string): string[] {
  const next = [tenantId, ...ids.filter((id) => id !== tenantId)].slice(
    0,
    MAX_RECENT,
  );
  return next;
}

export function useLastUsedTenant() {
  const [recentTenantIds, setRecentTenantIds] = useLocalStorage<string[]>(
    STORAGE_KEY,
    () => [],
  );

  const setLastUsedTenant = useCallback(
    (tenantId: string) => {
      setRecentTenantIds((prev) =>
        pushRecent(Array.isArray(prev) ? prev : [], tenantId),
      );
    },
    [setRecentTenantIds],
  );

  const lastUsedTenantId =
    Array.isArray(recentTenantIds) && recentTenantIds.length > 0
      ? recentTenantIds[0]
      : null;

  return {
    recentTenantIds: Array.isArray(recentTenantIds) ? recentTenantIds : [],
    lastUsedTenantId,
    setLastUsedTenant,
  };
}
